// import * as React from 'react';
import { Navbar, Icon, Row } from 'react-materialize'
import { Link } from "react-router-dom";


// const pages = [
//     { text: "Music", path: "/music" },
//     { text: "Videography", path: "/videography" },
// ];

function NavBar() {
    return (
        <Row>
            <Navbar
                alignLinks="right"
                brand={<Link to="/" className='Logo'>rein.likely</Link>}
                id="mobile-nav"
                className='Tool-bar'
                menuIcon={<Icon>menu</Icon>}
                options={{
                    draggable: true,
                    edge: 'left',
                    inDuration: 250,
                    // onCloseEnd: null,
                    // onCloseStart: null,
                    // onOpenEnd: null,
                    // onOpenStart: null,
                    outDuration: 200,
                    preventScrolling: true
                }}
            >
                {/* {pages.map((page, i) => (
                    <Link key={i} to={page.path}>
                        {page.text}
                    </Link>
                ))} */}
            </Navbar>
        </Row>
    );
}
export default NavBar;
